import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES = 'GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES';
export const GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_SUCCESS = 'GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_SUCCESS';
export const GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_FAIL = 'GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_FAIL';
export const GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_RESET = 'GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_RESET';

export const getVoiceAssistanceResponseMessages = (params) => ({
  type: GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES,
  params,
});

export const getVoiceAssistanceResponseMessagesSuccess = (response) => ({
  type: GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_SUCCESS,
  response,
});

export const getVoiceAssistanceResponseMessagesFail = (response) => ({
  type: GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_FAIL,
  response,
});

export const getVoiceAssistanceResponseMessagesReset = () => ({
  type: GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_RESET,
});

export const getVoiceAssistanceResponseMessagesApi = (data) => {
  return (dispatch) => {
    dispatch(getVoiceAssistanceResponseMessages());
    
    axios
      .get(`${config.api.base_url}/voice-assistance/va-response-messages`, {
        params: data,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getVoiceAssistanceResponseMessagesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getVoiceAssistanceResponseMessagesFail(error.response?.data || { message: error.message }));
      });
  };
};
